export default [
  "calendar-task-done ",
  "calendar-task-edited",
  "calendar-task-excluded",
  "calendar-task-rescheduled",
  "calendar-appointment-done ",
  "calendar-appointment-edited ",
  "calendar-appointment-excluded ",
  "calendar-appointment-rescheduled ",
  "calendar-deadline-done ",
  "calendar-deadline-edited ",
  "calendar-deadline-excluded",
  "calendar-hearing-done ",
  "calendar-hearing-edited ",
  "calendar-hearing-excluded ",
  "workplace-task-done",
  "workplace-task-excluded",
  "workplace-tasks-edited",
  "workplace-task-reassigned",
  "workplace-task-rescheduled",
  "workplace-tasklist-changed",
  "EMPTY_STATES_AUTOLAWSUITS_CLICKED",
  "EMPTY_STATES_CASES_CLICKED",
  "EMPTY_STATES_SKIPPED_CLICKED",
  "EMPTY_STATES_EXIT_CLICKED",
  "EMPTY_STATES_IGNORED_CLICKED",
  "EMPTY_STATES_COURT_NOT_FOUND_CLICKED",
  "EMPTY_STATES_SEARCH_LAWSUIT_MAINTENANCE",
  "EMPTY_STATES_SEARCH_OAB_MAINTENANCE",
  "EMPTY_STATES_SEARCH_CNA_CLICKED",
  "EMPTY_STATES_NEW_OAB_CLICKED",
  "EMPTY_STATES_FOLLOW_AUTOLAWSUIT_CLICKED",
  "EMPTY_STATES_CLIPPING_SEARCH_BY_OAB_FIRED",
  "EMPTY_STATES_CLIPPING_SEARCH_BY_OAB_SKIPPED",
  "clipping-accessed-by-alert",
  "clipping-accessed-by-module"
];
